import React from 'react';
import FacebookButton from "./facebook/FacebookButton";
import GoogleButton from './google/GoogleButton';

function SocialChannelsButtonsWrapper(props){
    return (
        <div className="alternative_login__ctas">
            <GoogleButton/>
            <FacebookButton/>
        </div>
    )
}

export default SocialChannelsButtonsWrapper;